import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import Input, { InputSizes, InputVariants } from "./input";

var Textarea = _extends({}, Input, {
  baseStyle: _extends({}, Input.baseStyle, {
    paddingY: "8px",
    minHeight: "80px",
    lineHeight: "short"
  })
});

export var TextareaVariants = InputVariants;
export var TextareaSizes = InputSizes;
export default Textarea;